import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { Grid, PageHeader, Form, FormGroup, Row, Col, FormControl, Button, ControlLabel } from 'react-bootstrap';
// LOCAL
import {login} from '../../user/actions'
import Logo from '../components/Logo'
import Card from '../Card'


const SplashMessageContainer = ({query}) =>
  <div className="common-container splash-message-container">
    <div className="">
      <div className="main-content-component">
        <Grid fluid={true}>
          <Row className="show-grid">
            <Col xs={12} sm={12} md={12}>
            <Card className="clients-tab-empty-state">
              <h2>{query.title}</h2>
              <h3>{query.message}</h3>
              <Button href={query.button_url} className="btn-main-green" bsSize="large" type="submit" >
               {query.button_title}
              </Button>
            </Card>
            </Col>
          </Row>
        </Grid>
      </div>
    </div>
  </div>


export default SplashMessageContainer



// WEBPACK FOOTER //
// ./src/core/containers/SplashMessageContainer.js